import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/vee-validate'
import store from './store'
import i18n from '@/lang'

import Amplify from '@aws-amplify/core'
import { Auth } from '@aws-amplify/auth'
import VueScrollTo from 'vue-scrollto'
import VuePapaParse from 'vue-papa-parse'
import dayjs from 'dayjs'

Amplify.configure({
  Auth: {
    identityPoolId: process.env.VUE_APP_ID_POOL_ID,
    region: process.env.VUE_APP_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: 'API',
        endpoint: process.env.VUE_APP_API_ENDPOINT,
        region: process.env.VUE_APP_REGION,
        custom_header: async function() {
          return { idtoken: (await Auth.currentSession()).idToken.jwtToken, Frontendversion: process.env.VUE_APP_FRONTEND_VER, utcOffset: String(dayjs().utcOffset() / 60)};
        }
      },
    ],
  },
  Storage: {
    AWSS3: {
      bucket: process.env.VUE_APP_S3_BUCKET,
      region: process.env.VUE_APP_REGION,
    },
  },
})

Vue.config.productionTip = false
Vue.use(VueScrollTo)
Vue.use(VuePapaParse)

new Vue({
  router,
  vuetify,
  store,
  i18n: i18n,
  render: function (h) {
    return h(App)
  },
}).$mount('#app')